

//Cart Gift Message
class CartGiftMessage extends HTMLElement{
  constructor(){
    super()
  }
  connectedCallback(){
    this.giftToggle = this.querySelector("[data-gift-toggle]");
    this.giftTextArea = this.querySelector("[data-gift-text-area]");
    this.textArea = this.giftTextArea?.querySelector(
      "[data-gift-text-area] textarea"
    );
    this.giftLabel = this.querySelector("[data-gift-label]");
    this.giftMessageConfirmationLabel = this.querySelector(
      "[data-gift-confirmation]"
    );
    this.giftAddRemoveButton = this.querySelector("[data-gift-add-remove]");

    this.giftMessageConfirmationActive = false;
    this.giftMessageConfirmationMessage = "";
    this.giftEnabled = false;
    this.showTextArea = false;

    this.giftToggle?.addEventListener("change", this.toggleGift.bind(this));
    this.giftAddRemoveButton?.addEventListener(
      "click",
      this.toggleGiftTextArea.bind(this)
    );
    this.giftTextArea?.addEventListener(
      "input",
      this.debouncedUpdateGiftMessage.bind(this)
    );
  }

  async getGiftMessage(cartObject) {
    if (
      !cartObject.attributes.giftEnabled &&
      !cartObject.attributes.giftMessage
    ) {
      this.giftEnabled = false;
    }
    if (
      cartObject.attributes.giftEnabled === "true" &&
      cartObject.attributes.giftMessage
    ) {
      this.giftEnabled = true;
      this.giftMessageEnabled = true;
      this.giftMessage = cartObject.attributes.giftMessage;
    }
    if (
      cartObject.attributes.giftEnabled === "true" &&
      !cartObject.attributes.giftMessage
    ) {
      this.giftEnabled = true;
      this.giftMessageEnabled = false;
    }
    if (cartObject.attributes.giftEnabled === "false") {
      this.giftEnabled = false;
    }
  }

  toggleGift() {
    console.log('toggle gift')
    if (this.giftEnabled) {
      this.giftEnabled = false;
      this.giftLabel.innerText = "Is this a Gift?";
      this.giftTextArea.style.display = "none";
      this.giftMessage = "";
      this.textArea.value = "";
      this.showTextArea = false;
      this.giftAddRemoveButton.style.display = "none";
      this.updateGiftMessage();
    } else {
      this.giftEnabled = true;
      this.giftLabel.innerText = "This is a Gift!";
      this.giftAddRemoveButton.querySelector("span.link__content").innerText =
        "Write Message";
      this.giftAddRemoveButton.style.display = "block";
    }
  }

  giftMessageConfirmation() {
    this.giftMessageConfirmationActive = true;
    this.giftMessageConfirmationLabel.innerText =
      this.giftMessageConfirmationMessage;
    this.giftMessageConfirmationLabel.style.display = "block";
    setTimeout(() => {
      this.giftMessageConfirmationLabel.style.display = "none";
    }, 2500);
  }

  toggleGiftTextArea() {
    if (this.showTextArea) {
      this.removeMessage();
      this.showTextArea = false;
      this.giftTextArea.style.display = "none";
      this.giftAddRemoveButton.querySelector("span.link__content").innerText =
        "Write Message";
    } else {
      this.showTextArea = true;
      this.giftAddRemoveButton.querySelector("span.link__content").innerText =
        "Remove Message";
      this.giftTextArea.style.display = "block";
    }
  }

  removeMessage() {
    if (this.giftMessage) {
      this.giftMessage = "";
      this.updateGiftMessage();
      this.giftMessageConfirmationMessage = "Message Removed";
      this.textArea.value = "";
      this.textArea.blur();
      this.giftMessageConfirmation();
    }
  }

  updateGiftMessage() {
    if (this.giftEnabled === true && this.giftMessage !== "") {
      if (checkSpecialChars(this.giftMessage)) {
        this.giftMessageConfirmationMessage =
          "Error! Please remove special characters and line breaks.";
        this.giftMessageConfirmation();
      } else {
        this.giftMessageConfirmationMessage = "Message Saved!";
        this.giftMessageSuccess = fetch(`${window.routes.cart_update_url}.js`, {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            attributes: {
              giftEnabled: this.giftEnabled,
              giftMessage: this.giftMessage,
            },
          }),
        });
      }
    }

    if (this.giftEnabled === true && this.giftMessage === "") {
      this.giftMessageSuccess = fetch(`${window.routes.cart_update_url}.js`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          attributes: {
            giftEnabled: this.giftEnabled,
          },
        }),
      });
    }

    if (this.giftEnabled === false) {
      this.giftMessageSuccess = fetch(`${window.routes.cart_update_url}.js`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          attributes: {
            giftEnabled: this.giftEnabled,
            giftMessage: "",
          },
        }),
      });
    }
  }

  debouncedUpdateGiftMessage(e) {
    this.giftMessage = e.target.value;
    this.giftMessageConfirmationActive = false;
    clearTimeout(this.timeout);
    let self = this;
    this.timeout = setTimeout(function () {
      self.updateGiftMessage();
      document.getElementById("giftMessageInput").blur();
      self.giftMessageConfirmation();
    }, 3000);
  }
}

customElements.define("cart-gift-message", CartGiftMessage);